export const PLAY_CARD = 'CARD/PLAY';
export const SHOW_HAND = 'CARD/SHOW_HAND';
export const ROUND_END = 'CARD/ROUND_END';


// WEBPACK FOOTER //
// ./src/gameBoard/actionTypes.js